import addAuthInterceptor from "@/api/interceptors/authInterceptor";

const configure = () => {
	addAuthInterceptor();
};

export default configure;
